export default type => dispatch => {
    try {
        if(type === "INCREASE") dispatch({ type: "INCREASE_APP_UPDATE_COUNT" })
        if(type === "RESET") dispatch({ type: "RESET_APP_UPDATE_COUNT" })
    } catch (error) {
        console.error("Err in updating AppUpdateCount", error)
    }
}